"use client";

import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      richColors
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-gradient-to-r group-[.toast]:from-rose-500 group-[.toast]:to-red-600 group-[.toast]:text-white group-[.toast]:border-0",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success:
            "group-[.toaster]:!bg-background group-[.toaster]:!text-foreground group-[.toaster]:border-rose-500/30 [&_[data-icon]>*]:!text-rose-500",
          error:
            "group-[.toaster]:!bg-background group-[.toaster]:!text-foreground group-[.toaster]:border-red-500/30 [&_[data-icon]>*]:!text-red-500",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
